const FEATURE_REQUEST_FIELDS = `
  items {
    ItemId
    CreatedDate
    CreatedBy
    LastUpdatedDate
    title
    description
    status
    issueNumber
    projectUrl
    authorSnapshot {
      firstName
      lastName
      email
      profileImageUrl
    }
  }
`;

// One board column's page: callers scope `where` to a single `status` (plus
// `CreatedBy` for a member's own requests), so `totalCount` doubles as the
// column's header count.
export const GET_FEATURE_REQUESTS_QUERY = `
  query GetFeatureRequests(
    $where: featureRequestFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getfeatureRequests(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      ${FEATURE_REQUEST_FIELDS}
    }
  }
`;

export const INSERT_FEATURE_REQUEST_MUTATION = `
  mutation InsertFeatureRequest($input: featureRequestInsertInput!) {
    insertfeatureRequest(input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_FEATURE_REQUEST_MUTATION = `
  mutation UpdateFeatureRequest(
    $itemId: String!
    $title: String
    $description: String
  ) {
    updatefeatureRequest(
      where: { ItemId: { eq: $itemId } }
      input: { title: $title, description: $description }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk update: refresh the author snapshot on every request by this user after
// a profile edit (used by user-name-snapshot-sync).
export const UPDATE_MANY_FEATURE_REQUEST_AUTHOR_SNAPSHOT = `
  mutation UpdateManyFeatureRequestAuthorSnapshot(
    $createdBy: String!
    $firstName: String
    $lastName: String
    $email: String
    $profileImageUrl: String
  ) {
    updateManyfeatureRequest(
      where: { CreatedBy: { eq: $createdBy } }
      input: {
        authorSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
        }
      }
    ) {
      acknowledged
      totalImpactedData
      message
    }
  }
`;
